import { AxiosResponse, AxiosError } from "axios";
import { useMutation } from "react-query";

import useAxios from "@src/config/axios/useAxios";
import { getSetAsBenchmarkUrl } from "@src/config/baseUrls";

const useSetBenchmarkStatus = (studyId: string, testId: string) => {
  const axios = useAxios();

  return useMutation<AxiosResponse<string>, AxiosError, boolean>(
    ["setAsBenchmark", studyId, testId],
    (status: boolean) =>
      axios.put(getSetAsBenchmarkUrl(studyId, testId), { status }),
  );
};

export default useSetBenchmarkStatus;
